import React from "react";

const Products = ({ product }) => {
  return (
    <>
      <div className="product">
        <ul className="product__list">
          {product.map(({ skill_image, skill_name }, index) => {
            return (
              <li className="product__item" key={index}>
                <img src={skill_image} alt="" />
                <h4 className="heading">{skill_name}</h4>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Products;
